import { Message } from "@/modules/staff/objects/conversation/Message";

export default {
  voiceToTextAction(state: any): any {
    return state.voiceToTextAction;
  },
  subscribedUnreadMessage(state: any): any {
    return state.subscribedUnreadMessage;
  },
  unreadMessageData(state: any): any {
    return state.unreadMessageData;
  },
  // wasn't there before - deprecated?
  subscribedUser(state: any): any {
    return state.subscribedUser;
  },
  // test subscription
  subscriptionsOnPage(state: any): [any] {
    return state.subscriptionsOnPage;
  },
  // test subscription
  eventDataList(state: any): [any] {
    return state.eventDataList;
  },
  hasStartedAppSyncSubscription(state: any): boolean {
    return state.hasStartedAppSyncSubscription;
  },
  currentMessages(state: any): Message[] {
    return state.currentMessages;
  },
  currentMessagesWithStaff(state: any): Message[] {
    return state.currentMessagesWithStaff;
  },
  currentConversationId(state: any): string {
    return state.currentConversationId;
  },
  currentConversationIdWithStaff(state: any): string {
    return state.currentConversationIdWithStaff;
  },
  currentConversationHideContact(state: any): boolean {
    return state.currentConversationHideContact;
  },
  conversationSurveyScores(state: any): any[] {
    return state.conversationSurveyScores;
  },
  conversationIds(state: any): string[] {
    return state.conversationIds;
  },
  voiceChatStartingAction(state: any): any {
    return state.voiceChatStartingAction;
  },
  voiceChatRespondAction(state: any): any {
    return state.voiceChatRespondAction;
  },
  showNewIcon(state: any): boolean {
    return state.showNewIcon;
  },
  importance(state: any): any {
    return state.importance;
  },
  forwardInquiryId(state: any): number {
    return state.forwardInquiryId;
  },
  fromInquiryHistory(state: any): any {
    return state.fromInquiryHistory;
  },
  isContactButtonView(state: any): boolean {
    return state.isContactButtonView;
  },
  ticketQueueConversationReloadNeeded(state: any): boolean {
    return state.ticketQueueConversationReloadNeeded;
  },
  noStaffCanRespondVoiceChatNotification(state: any): boolean {
    return state.noStaffCanRespondVoiceChatNotification;
  },
  ticketQueueStopInquiry(state: any): boolean {
    return state.ticketQueueStopInquiry;
  },
  showGuestLoading(state: any): boolean {
    return state.showGuestLoading;
  },
  runningEllipse(state: any): any {
    return state.runningEllipse;
  },
  guestRunningEllipse(state: any): any {
    return state.guestRunningEllipse;
  },
  pwaGuestRunningEllipse(state: any): any {
    return state.pwaGuestRunningEllipse;
  },
  getFirstMessageFromGuest(state: any): any {
    return state.firstMessageFromGuest;
  },
  getUnreadMessages(state: any): any {
    return state.unreadMessages;
  },
  getDisableIncognitoModeNotification(state: any): any {
    return state.disableIncognitoModeNotification;
  },
  getAlreadyNotifiedIncognitoMode(state: any): boolean {
    return state.alreadyNotifiedIncognitoMode;
  },
  getNotifyIncognitoMode(state: any): boolean {
    return state.notifyIncognitoMode;
  },
};
